import Loading from '@cartwhl/ui/atoms/Loading';

import { useStore } from '../dashboardStore';
import DashboardAccessEmptyState from './DashboardAccessEmptyState';
import DashboardAppletGrid from './DashboardAppletGrid';
import DashboardWorkList from './DashboardWorkList';

export default function DashboardHome() {
  const dashboardStore = useStore();
  const { customerApplets, userStoreLoading } = dashboardStore.state;

  if (userStoreLoading) {
    return (
      <div className="flex min-h-[240px] flex-col items-center justify-center gap-4">
        <Loading className="text-tertiary h-10 w-10" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-14">
      <DashboardAppletGrid
        title="How do you want to create today?"
        applets={customerApplets}
        emptyState={<DashboardAccessEmptyState />}
      />
      <DashboardWorkList />
    </div>
  );
}
